// extracted by mini-css-extract-plugin
export default {"sticker":"styles_sticker__n+FX0","content":"styles_content__v3J2D","legend":"styles_legend__4pYTr"};